import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AreaFilterService {

  /**
   * Get the logged-in user's area names from localStorage
   */
  getLoggedInAreaNames(): string[] {
    let areaNames: string[] = [];

    try {
      const stored = JSON.parse(window.localStorage.getItem("areaNames") || "[]");
      if (Array.isArray(stored)) {
        areaNames = stored;
      }
    } catch (e) {
      console.warn("Invalid areaNames in localStorage", e);
    }

    return areaNames;
  }

  /**
   * Filter employees by their areas based on logged-in user's area names
   */
  filterEmployeesByArea(employees: any[]): any[] {
    const areaNames = this.getLoggedInAreaNames();

    // If no area filter is set (empty array), return all employees
    if (areaNames.length === 0) {
      return employees;
    }

    return employees.filter((emp: any) => {
      return emp.areas && emp.areas.some((area: any) => areaNames.includes(area.areaName));
    });
  }

  /**
   * Filter areas based on logged-in user's area names
   */
  filterAreasByAreaName(areas: any[]): any[] {
    const areaNames = this.getLoggedInAreaNames();

    // If no area filter is set (empty array), return all areas
    if (areaNames.length === 0) {
      return areas;
    }

    return areas.filter((area: any) => areaNames.includes(area.areaName));
  }

  /**
   * Filter complaints by selectedArea based on logged-in user's area names
   */
  filterComplaintsByArea(complaints: any[]): any[] {
    const areaNames = this.getLoggedInAreaNames();

    // If no area filter is set (empty array), return all complaints
    if (areaNames.length === 0) {
      return complaints;
    }

    return complaints.filter((complaint: any) => {
      return areaNames.includes(complaint.selectedArea);
    });
  }

  /**
   * Recursively filter arrays in an API response by areaCode/areaName.
   * Keeps primitives and objects without area fields unchanged.
   */

  /**
   * Filter customers by their area based on logged-in user's area names
   */
  filterCustomersByArea(customers: any[]): any[] {
    const areaNames = this.getLoggedInAreaNames();

    // If no area filter is set (empty array), return all customers
    if (areaNames.length === 0) {
      return customers;
    }

    return customers.filter((customer: any) => {
      return areaNames.includes(customer.areaName);
    });
  }

  /**
   * Filter expenses by area_name based on logged-in user's area names
   */
  filterExpensesByArea(expenses: any[]): any[] {
    const areaNames = this.getLoggedInAreaNames();

    // If no area filter is set (empty array), return all expenses
    if (areaNames.length === 0) {
      return expenses;
    }

    return expenses.filter((expense: any) => {
      return areaNames.includes(expense.area_name);
    });
  }

  /**
   * Generic filter for any array with an areaName / area_name property
   */
  filterByAreaName(items: any[]): any[] {
    const areaNames = this.getLoggedInAreaNames();

    // If no area filter is set (empty array), return all items
    if (areaNames.length === 0) {
      return items;
    }

    return items.filter((item: any) => {
      const area = item.areaName || item.area_name || item.selectedArea || '';
      return areaNames.includes(area);
    });
  }
}
